console.log('Cart savings script starting');

// Main script wrapper
(function() {
  // First verify settings
  if (!window.theme?.settings?.cartSavings?.enabled) {
    console.log('Cart savings functionality is disabled');
    return;
  }

  async function calculateCartSavings(cart) {
    console.log('=== Starting Savings Calculation ===');
    console.log('Cart total:', cart.total_price / 100);
    
    let totalSavings = 0;
    let freeGiftValues = 0;

    // Check if spend & save is enabled and get free gift handles if it is
    const spendSaveEnabled = window.theme?.settings?.spendAndSave?.rewardsConfig != null;
    const freeGiftHandles = new Set();
    
    if (spendSaveEnabled) {
      console.log('Spend & Save is enabled, checking for free gifts');
      window.theme.settings.spendAndSave.rewardsConfig
        .filter(reward => reward.type === 'FREE GIFT')
        .forEach(reward => {
          reward.giftHandle.split('|')
            .map(h => h.trim())
            .forEach(handle => freeGiftHandles.add(handle));
        });
    }
    
    // Process each cart item
    for (const item of cart.items) {
      console.log(`\n=== Processing item: ${item.title} ===`);
      
      // Skip shipping protection
      if (item.handle === 'shipping-protection') {
        console.log('Skipping shipping protection item');
        continue;
      }

      // Handle free gifts from spend & save if enabled
      if (spendSaveEnabled && freeGiftHandles.has(item.handle)) {
        console.log('Found free gift item:', item.title);
        const matchingReward = window.theme.settings.spendAndSave.rewardsConfig
          .find(reward => reward.type === 'FREE GIFT' && 
            reward.giftHandle.split('|').map(h => h.trim()).includes(item.handle));
        
        if (matchingReward) {
          const giftValue = matchingReward.giftValue * item.quantity;
          freeGiftValues += giftValue;
          console.log('Added free gift value:', giftValue / 100);
        }
        continue;
      }

      try {
        // Fetch full product data from Shopify
        const response = await fetch(`/products/${item.handle}.js`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const product = await response.json();
        
        // Find the matching variant
        const variant = product.variants.find(v => v.id === item.variant_id);
        
        if (variant) {
          // Use compare_at_price if available, otherwise use the regular price
          const fullPricePerItem = variant.compare_at_price || variant.price;
          const currentPrice = item.final_line_price;
          const fullPrice = fullPricePerItem * item.quantity;
          
          console.log('Found variant data:', {
            product: product.title,
            variant: variant.title,
            compare_at_price: variant.compare_at_price ? variant.compare_at_price / 100 : 'N/A',
            regular_price: variant.price / 100,
            price_used: fullPricePerItem / 100,
            quantity: item.quantity,
            current_line_price: currentPrice / 100
          });

          const itemSavings = fullPrice - currentPrice;

          console.log('Savings calculation:', {
            fullPricePerItem: fullPricePerItem / 100,
            fullPriceTotal: fullPrice / 100,
            currentPrice: currentPrice / 100,
            itemSavings: itemSavings / 100
          });

          if (itemSavings > 0) {
            totalSavings += itemSavings;
            console.log(`Running total savings: $${totalSavings / 100}`);
          }
        }
      } catch (error) {
        console.error('Error fetching product data:', error);
      }
    }

    // Add free gift values if any were found
    if (freeGiftValues > 0) {
      console.log('\nAdding free gift value:', freeGiftValues / 100);
      totalSavings += freeGiftValues;
      console.log('New total with free gifts:', totalSavings / 100);
    }

    console.log('\nFinal Breakdown:', {
      savingsBeforeFreeGifts: (totalSavings - freeGiftValues) / 100,
      freeGiftValue: freeGiftValues / 100,
      finalTotalSavings: totalSavings / 100
    });
    
    return totalSavings;
  }

  async function updateCartSavingsMessage() {
    console.log('=== Starting Savings Message Update ===');
    
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const totalSavings = await calculateCartSavings(cart);
      
      let savingsRow = document.querySelector('.cart-savings-message');
      const subtotalRow = document.querySelector('.subtotal');
      
      if (totalSavings > 0) {
        if (!savingsRow) {
          // Create new savings row if it doesn't exist
          savingsRow = document.createElement('div');
          savingsRow.className = 'cart-savings-message';
          
          // Add CSS animation styles if needed
          if (!document.querySelector('#cart-savings-styles')) {
            const style = document.createElement('style');
            style.id = 'cart-savings-styles';
            style.textContent = `
              @keyframes savingsPulse {
                0% { opacity: 1; transform: scale(1); }
                50% { opacity: 0.85; transform: scale(1.02); }
                100% { opacity: 1; transform: scale(1); }
              }
              .cart-savings-message {
                text-align: right;
                font-size: 1.1em;
                color: ${window.theme.settings.cartSavings.textColor};
                margin-top: -14px;
                transition: opacity 0.3s ease;
                font-weight: bold;
              }
              .cart-savings-message.pulse {
                animation: savingsPulse 0.5s ease-in-out;
              }
            `;
            document.head.appendChild(style);
          }
          
          if (subtotalRow) {
            let wrapper = subtotalRow.parentElement;
            if (!wrapper.classList.contains('subtotal-wrapper')) {
              wrapper = document.createElement('div');
              wrapper.className = 'subtotal-wrapper';
              subtotalRow.parentElement.insertBefore(wrapper, subtotalRow);
              wrapper.appendChild(subtotalRow);
            }
            wrapper.appendChild(savingsRow);
          }
        }
        
        const newSavingsText = `You Have Saved $${(totalSavings / 100).toFixed(2)}`;
        
        // Only trigger animation if the text has changed
        if (savingsRow.textContent !== newSavingsText) {
          savingsRow.textContent = newSavingsText;
          savingsRow.classList.remove('pulse');
          void savingsRow.offsetWidth;
          savingsRow.classList.add('pulse');
        }
        
        savingsRow.style.display = 'block';
      } else if (savingsRow) {
        savingsRow.style.opacity = '0';
        setTimeout(() => savingsRow.remove(), 300);
      }
    } catch (error) {
      console.error('Error updating savings message:', error);
    }
  }

  // Debounce utility
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Create debounced version of the update function
  const debouncedUpdateSavings = debounce(updateCartSavingsMessage, 300);

  // Set up event listeners
  document.addEventListener('DOMContentLoaded', updateCartSavingsMessage);
  document.addEventListener('on:cart:after-merge', debouncedUpdateSavings);

  // Make update function available globally
  window.updateCartSavings = updateCartSavingsMessage;

  console.log('Cart savings script initialization complete');
})();